var ExtensionRegistry = /*#__PURE__*/function () {
  function ExtensionRegistry() {
    this.extensions = {};
  }
  var _proto = ExtensionRegistry.prototype;
  _proto.getExtensions = function getExtensions(point) {
    if (this.extensions[point]) {
      return Object.values(this.extensions[point]);
    }
    return [];
  };
  _proto.contributeExtension = function contributeExtension(point, extension) {
    // initialize extension point if it was not initialized yet
    if (!this.extensions[point]) {
      this.extensions[point] = {};
    }
    if (this.extensions[point][extension.id]) {
      throw new Error("\n        Extension with the same id '" + extension.id + "' already exist. This can happens either:\n        - when contribution was executed in React runtime and event such as rerender caused the override. \n          In this case place the contribution logic to the top-level loadtime initialization \n          of your micro-app.\n        - you just defined two extensions with the same ids. Extension id must be unique.\n      ");
    }
    this.extensions[point][extension.id] = extension.config;
  };
  return ExtensionRegistry;
}();
if (typeof window !== 'undefined') {
  if (!window.__registry) {
    window.__registry = /*#__PURE__*/new ExtensionRegistry();
  }
}
var ExtensionRegistry$1 = window.__registry;

export default ExtensionRegistry$1;
//# sourceMappingURL=oneapp-extensibility.esm.js.map
